import React from "react";
import { useNavigate } from "react-router-dom";
import { Guitar, Music, BookOpen, Activity, Dumbbell, Sprout } from "lucide-react";

const modules = [
  { id: "songs", label: "Canciones", icon: Music, color: "#7B2335" },
  { id: "scales", label: "Escalas", icon: BookOpen, color: "#A07840" },
  { id: "chords", label: "Acordes", icon: Guitar, color: "#5A7A3A" },
  { id: "melodies", label: "Melodías", icon: Activity, color: "#3A6080" },
  { id: "fingers", label: "Gimnasio", icon: Dumbbell, color: "#6A5080" },
];

export const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen bg-[#F3EDE3] flex items-center justify-center relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-30">
        <svg className="w-full h-full" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
          <line x1="100" y1="200" x2="1100" y2="200" stroke="#D4CBC0" strokeWidth="1" />
          <line x1="100" y1="300" x2="1100" y2="300" stroke="#D4CBC0" strokeWidth="1.2" />
          <line x1="100" y1="400" x2="1100" y2="400" stroke="#D4CBC0" strokeWidth="1.5" />
          <line x1="100" y1="500" x2="1100" y2="500" stroke="#D4CBC0" strokeWidth="1.2" />
          <line x1="100" y1="600" x2="1100" y2="600" stroke="#D4CBC0" strokeWidth="1" />
          <line x1="200" y1="150" x2="200" y2="650" stroke="#D4CBC0" strokeWidth="0.5" />
          <line x1="400" y1="150" x2="400" y2="650" stroke="#D4CBC0" strokeWidth="0.5" />
          <line x1="600" y1="150" x2="600" y2="650" stroke="#D4CBC0" strokeWidth="0.5" />
          <line x1="800" y1="150" x2="800" y2="650" stroke="#D4CBC0" strokeWidth="0.5" />
          <line x1="1000" y1="150" x2="1000" y2="650" stroke="#D4CBC0" strokeWidth="0.5" />
        </svg>
      </div>

      {/* Center content */}
      <div className="relative z-10 text-center max-w-2xl px-8" style={{ animation: "fadeUp 0.8s ease-out" }}>
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#7B2335] shadow-xl mb-6">
            <Guitar className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-5xl font-bold text-[#2C2825] mb-3 tracking-tight">
            <span className="font-sans">Edusico</span>
            <span className="font-serif italic"> Bordona</span>
          </h1>
          <p className="text-lg text-[#8A8078] font-sans max-w-md mx-auto leading-relaxed">
            Tu taller interactivo para dominar el mástil. Parte del ecosistema pedagógico <span className="text-[#7B2335] font-semibold">Edusico</span>.
          </p>
        </div>

        {/* Module pills */}
        <div className="flex justify-center gap-2 mb-10 flex-wrap">
          {modules.map((mod) => (
            <button
              key={mod.id}
              onClick={() => navigate(`/${mod.id}`)}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-[#D4CBC0] shadow-sm hover:shadow-md hover:border-[#B8AEA3] transition-all text-sm font-sans text-[#5A524A]"
            >
              <mod.icon className="w-4 h-4" style={{ color: mod.color }} />
              {mod.label}
            </button>
          ))}
        </div>

        <div className="flex flex-col items-center gap-3">
          <button
            onClick={() => navigate("/scales")}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-xl bg-[#7B2335] text-white font-sans font-medium text-sm hover:bg-[#5A1A28] shadow-lg shadow-[#7B2335]/20 transition-all hover:scale-105"
          >
            Entrar al taller
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>

          <button
            onClick={() => {
              localStorage.removeItem("bordona-onboarded");
              navigate("/fingers");
            }}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-white border border-[#D4CBC0] text-[#5A7A3A] font-sans font-medium text-sm hover:bg-[#F5F0E8] hover:border-[#5A7A3A]/30 shadow-sm transition-all hover:scale-105"
          >
            <Sprout className="w-4 h-4" />
            Nunca toque guitarra — Empieza aqui
          </button>
        </div>

        <p className="mt-8 text-xs text-[#B8AEA3] font-sans">
          v1.0 · Desarrollado para el aula de música
        </p>
      </div>
    </div>
  );
};

export default WelcomePage;
